/**
 * Vacancy view counter beacon.
 *
 * Pings POST {endpoint} once on load so the vacancy's `_vacancy_views` meta is
 * incremented even when WP-Rocket serves a fully cached page (PHP never runs on
 * cached hits, so the count cannot be done at render time). Fire-and-forget: the
 * displayed count is server-rendered on the next page load, so the response is
 * ignored and failures are swallowed. Config is injected as `window.G4ZVacancyView`
 * ({ endpoint }) by Theme::stylesAndScripts(), scoped to single vacancy pages.
 */
(function () {
  "use strict";

  var config = window.G4ZVacancyView;
  if (!config || !config.endpoint) {
    return;
  }

  function ping() {
    try {
      fetch(config.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      }).catch(function () {});
    } catch (e) {
      /* no-op: counting is best-effort */
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ping);
  } else {
    ping();
  }
})();
